/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Time range for the caller's Organization Gateway activity
 */
export type GetOrganizationGatewayActivityPayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export type GetOrganizationGatewayActivityPayload$Outbound = {
  from: string;
  to: string;
};

/** @internal */
export const GetOrganizationGatewayActivityPayload$outboundSchema:
  z.ZodMiniType<
    GetOrganizationGatewayActivityPayload$Outbound,
    GetOrganizationGatewayActivityPayload
  > = z.object({
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  });

export function getOrganizationGatewayActivityPayloadToJSON(
  getOrganizationGatewayActivityPayload: GetOrganizationGatewayActivityPayload,
): string {
  return JSON.stringify(
    GetOrganizationGatewayActivityPayload$outboundSchema.parse(
      getOrganizationGatewayActivityPayload,
    ),
  );
}
